//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { PAGINATION_OPTIONS } from '@apis/campaign-requests/shared/Pagination';
import { TablePaginationControls } from '@components/molecules/pagination/TablePaginationControls';

interface Props {
  currentPage: number;
  itemsPerPage: number;
  setCurrentPage: (page: number) => void;
  setItemsPerPage: (itemsPerPage: number) => void;
  totalItems: number;
}

export const PurchaseOptionsPagination = ({
  currentPage,
  itemsPerPage,
  setCurrentPage,
  setItemsPerPage,
  totalItems,
}: Props) => (
  <TablePaginationControlsWrapper>
    <TablePaginationControls
      currentPage={currentPage}
      handlePageChange={(currentPage: number, itemsPerPage: number) => {
        setCurrentPage(currentPage);
        setItemsPerPage(itemsPerPage);
      }}
      itemsPerPage={itemsPerPage}
      itemsPerPageOptions={PAGINATION_OPTIONS}
      numItems={totalItems}
    />
  </TablePaginationControlsWrapper>
);

const TablePaginationControlsWrapper = styled.div(
  ({ theme }) => `
  margin-top: ${theme.spacings[3]};
`,
);
